import { TopupStatusTitles } from '@/entities/topups'
import { TopupStatistic } from '@/features/dashboardMerchant/model'
import { formatCurrency } from '@/shared/lib/currency'
import { formatDate } from '@/shared/lib/date'
import { getBankMeta } from '@/shared/utils/getBankMeta'
import { getShortenId } from '@/shared/utils/getShortenId'
import { ColumnDef } from '@tanstack/react-table'
import { Link } from 'react-router-dom'
import { formatCardOrPhone } from '@/features/orders'
import { CopyBlock } from '@/shared/components/CopyBlock/CopyBlock'

export const payoutColumns: ColumnDef<TopupStatistic>[] = [
  {
    accessorKey: 'id',
    header: () => <div>ID заявки</div>,
    cell: ({ row }) => {
      const id = row.getValue<string>('id')
      return (
        <Link to={`/deals/${id}`}>
          <span className="font-medium text-primary dark:text-primary-dark text-sm" title={id}>
            {getShortenId(id)}
          </span>
        </Link>
      )
    },
  },
  {
    accessorKey: 'date',
    header: 'Дата и время',
    cell: ({ row }) => {
      return (
        <span className="font-medium text-sm">
          {formatDate(row.original.createdAt, 'dateShortAndTimeWithoutSec')}
        </span>
      )
    },
  },
  {
    accessorKey: 'amount',
    header: 'Сумма',
    cell: ({ row }) => {
      return (
        <div className="flex flex-col">
          <CopyBlock text={row.original.amountTo?.toFixed(2)}>
            {formatCurrency(row.original.amountTo ?? 0, row.original.currencyTo)}
          </CopyBlock>

          <CopyBlock text={row.original.amountFrom?.toFixed(2)} color="secondary">
            {formatCurrency(row.original.amountFrom ?? 0, row.original.currencyFrom)}
          </CopyBlock>
        </div>
      )
    },
  },
  {
    accessorKey: 'requisite',
    header: 'Реквизит',
    cell: ({ row }) => {
      return (
        <div className="flex flex-col">
          <CopyBlock text={row.original.paymentRequisitValue}>
            {formatCardOrPhone(row.original.paymentRequisitValue ?? '')}
          </CopyBlock>

          <span className="text-text-secondary">
            {row.original.bankFrom && getBankMeta(row.original.bankFrom).title}
          </span>
        </div>
      )
    },
  },
  {
    accessorKey: 'status',
    header: 'Статус',
    cell: ({ row }) => {
      const status = row.original.topupStatus
      const title = TopupStatusTitles[status]
      return <span className="font-medium text-sm">{title}</span>
    },
  },
]
